// extracted by mini-css-extract-plugin
export default {"zoomControls":"Pfa-z","zoomControlButton":"Qfa-z","zoomBanner":"Rfa-z","bannerButton":"Sfa-z","imageButton":"Tfa-z","zoom":"Ufa-z","zoomContent":"Vfa-z"};